import { AlertCircle, RefreshCw } from "lucide-react";
import { ZButton } from "@/shared/components/button";

export function PageErrorFallback() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="w-full h-full flex flex-col items-center justify-center bg-white rounded-xl p-8">
      <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
      <h2 className="text-lg font-semibold text-gray-900 mb-2">
        Something went wrong
      </h2>
      <p className="text-sm text-gray-500 mb-6 text-center max-w-md">
        We encountered an error loading this page. Please try refreshing.
      </p>
      <ZButton
        color="primary"
        onClick={handleReload}
        startContent={<RefreshCw className="w-4 h-4" />}
      >
        Refresh Page
      </ZButton>
    </div>
  );
}
